export type AppLanguage = 'pl' | 'en'

export const SUPPORTED_LANGUAGES: AppLanguage[] = ['pl', 'en']

export const DEFAULT_LANGUAGE: AppLanguage = 'pl'

export const LOCALE_STORAGE_KEY = 'questwise_locale'

export const LANGUAGE_INTL_LOCALE: Record<AppLanguage, string> = {
  pl: 'pl-PL',
  en: 'en-GB',
}

export function isAppLanguage(value: string | undefined | null): value is AppLanguage {
  return value === 'pl' || value === 'en'
}
